<template>
<div>
<navbar :title="fad" :box="box"/>
<van-form v-if="form===1" @submit="onSubmit">
  <van-field
    v-model="ref_kod"
    label="Referans"
    name="Referans"
    placeholder="Referans Kodu"
    :rules="[{ required: true, message: 'Referans boş geçilemez' }]"
    @blur="sponsorkontrol"
  />
    <van-field
    v-model="tc"
    label="Tc Kimlik"
    placeholder="Tc Kimlik No"
    :rules="[{ required: true, message: 'Tc Kimlik boş geçilemez' }]"
    @blur="tcno"
  />
  <van-field
    v-model="isim"
    label="İsim"
    placeholder="Ad ve Soyad"
    :rules="[{ required: true, message: 'isim boş geçilemez' }]"
  />
  <van-field
    v-model="pass"
    type="password"
    label="Şifre"
    placeholder="Şifre"
    :rules="[{ required: true, message: 'Şifre boş geçilemez' }]"
  />
    <van-field
    v-model="pass2"
    type="password"
    label="Şifre"
    placeholder="Şifre Tekrar"
    :rules="[{ required: true, message: 'şifreler uyuşmuyor' }]"
  />
  <div style="margin: 16px;">
    <van-button round block type="info" native-type="submit">Gönder</van-button>
  </div>
</van-form>
<van-form v-else @submit="onUpdate">
  <van-field
    v-model="posta"
    label="E-Posta"
    name="E-posta"
    placeholder="E-posta Adresi"
    :rules="[{ required: true, message: 'E-Posta boş geçilemez' }]"
  />
    <van-field
    v-model="cep"
    label="Telefon"
    placeholder="Mobil Telefon"
    :rules="[{ required: true, message: 'Telefon boş geçilemez' }]"
  />
  <van-field
    v-model="il"
    label="İl"
    placeholder="il"
    :rules="[{ required: true, message: 'il boş geçilemez' }]"
  />
  <van-field
    v-model="ilce"
    label="İlçe"
    placeholder="ilçe"
    :rules="[{ required: true, message: 'ilçe boş geçilemez' }]"
  />
  <van-field
    v-model="adres"
    label="Adres"
    placeholder="Kısace Adresiniz"
    :rules="[{ required: true, message: 'Adres boş geçilemez' }]"
  />
  <van-field name="tip" label="">
  <template #input>
    <van-radio-group v-model="tip"  direction="horizontal">
      <van-radio @click="tip='0'" name="0">Bireysel Bayi</van-radio>
      <van-radio @click="tip='1'" name="1">Kurumsal Bayi</van-radio>
    </van-radio-group>
  </template>
</van-field>
<!--kurumsal -->
  <van-field v-if="tip==='1'"
    v-model="unvan"
    label="Ünvan"
    name="unvan"
    placeholder="Fatura Başlığı"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
    <van-field v-if="tip==='1'"
    v-model="vd"
    label="Vergi D."
    placeholder="Vergi Dairesi"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
    @blur="tcno"
  />
  <van-field v-if="tip==='1'"
    v-model="vno"
    label="Vergi No"
    placeholder="Vergi Numarası"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
  <van-field v-if="tip==='1'"
    v-model="fadres"
    label="Adres"
    placeholder="Fatura Adresi"
    :rules="[{ required: true, message: 'Boş geçilemez' }]"
  />
  <div style="margin: 16px;">
    <van-button round block type="info" native-type="submit">Gönder</van-button>
  </div>
</van-form>
<van-popup v-model="show"><van-loading type="spinner" color="#fff" /></van-popup>

</div>
</template>

<script>
import {helper} from '@/helper';
import { userService } from '@/plugins/_services';
import {Toast} from 'vant'
import navbar from './nav'
import { Dialog } from 'vant';
import { Notify } from 'vant';

export default {
  components:{
    navbar
  },
  data() {
    return {
       posta:'',
       cep:'',
       il:'',
       ilce:'',
       adres:'',
       unvan:'',
       vd:'',
       vno:'',
       fadres:'',
       tip:'0',
       form:1,
       yeniuyekod:'',
       ref_kod:'',
       tc:'',
       isim:'',
       pass:'',
       pass2:'',
       show:false,
       fad:'Yeni Bayi',
       ref_kod:helper.settings.ayar().uye,
       box:JSON.parse(localStorage.getItem('ayuBox')).baskets.length || 0,
       gun:helper.settings.donem().gun,
       aay:helper.settings.donem().ay,
       ayil:parseInt(helper.settings.donem().yil),       
    };
  },
  created (){
    this.show = true
    userService.handleResponse(helper.settings.ayar().username,helper.settings.ayar().pass)
    .then(res => {this.show = false })
    .catch(err => {userService.logout()})
  },
  methods : {
      sponsorkontrol(){
        if (this.ref_kod)
        {
          this.show=true
          this.uye_kod_kontrol(this.ref_kod)
          .then(res=> {
            this.show=false
            Toast(res.ad)
          })
          .catch(err=>{
            this.show=false
            Toast("Sponsor Kodu Hatalı")
            this.ref_kod = ''
        })          
        }

      },    
      onSubmit(){
        if (this.pass === this.pass2){
          Dialog.confirm({
          title: 'Bayi Eklenecek',
          message:'Onaylıyormusunuz ?',
          }).then((result) => {
            this.show = true
            this.uye_kod_kontrol(Math.floor(Math.random() * 10000000000) + 1)
              .then(err=>{
                this.onSubmit()
              })
              .catch(res=>{
                  let data = {
                    uye_kod : res.kod,
                    ref_kod: this.ref_kod,
                    tcno : this.tc,
                    uye_ad : this.isim,
                    parola: this.pass,
                    kariyer_id : 1,
                    gun : this.gun, 
                    ay : this.aay, 
                    yil : this.ayil, 
                  }
                  helper.request.post('bayi',data)
                  .then(response=>{
                      helper.request.post('bayi_bilgi',{table:'uye_bilgi',uye_kod:response.kod})
                        .then(resp=> {
                          this.yeniuyekod = resp.kod
                          helper.request.post('bayi_bilgi',{table:'uye_banka',uye_kod:resp.kod})
                          .then(()=>{
                            Toast("Yeni Kayıt Başarılı")
                             this.form = 2
                             this.show = false
                          })
                        })

                  })
                  .catch(err => {Toast('Tekrar Dene : '+err.message)
                  this.show = false
                  })               
              })

          })
          .catch(err=>{this.show=false})
        }
        else{
          Notify({ type: 'danger', message: 'Şifreler uyuşmuyor' });
        }
      },
      uye_kod_kontrol(value){
      return new Promise((resolve, reject) => {
          helper.request.get("uye_kod/"+value)
          .then(res=>{
          
            if (res.status){ resolve({
              status:res.status,
              kod:value,
              ad:res.ad
            })}
            else{ reject({
              kod:value
            }) }
          })
      })        
      },
      tcno(){
        helper.funcs.tckontrol(this.tc)
        .then(res => {
          if (res){
            helper.request.get("tckontrol/"+this.tc)
              .then(response=>{
                if (!response.status){
                  Notify({ type: 'danger', message: 'Tc Kimlik Kullanılıyor' });
                  this.tc = ''
                }
              })
          }
          else{
            Notify({ type: 'danger', message: 'Tc Kimlik yapısı uygun değil' });
            this.tc = ''
          }
        })
      },
      onUpdate(){
        this.show = true
        let data = {
          email:this.posta,
          gsm:this.cep,
          il:this.il,
          ilce:this.ilce,
          adres:this.adres,
          unvan:this.unvan,
          vd:this.vd,
          vno:this.vno,
          fadres:this.fadres,
          tip:this.tip,
          uye_kod:this.yeniuyekod,
        }
        helper.request.post('update_uye_bilgi',data)
        .then(res=>{
          Toast("Güncelleme Başarılı")
          this.show = false
        })
        .catch(err => {
          Toast("Tekrar Dene : "+err )
          this.show = false
        })
      }

  } 
};
</script>


// WEBPACK FOOTER //
// src/components/bayi.vue